import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import api from '../../services/api';

const { TextArea } = Input;

/**
 * Submits to the same public /enquiries-submit endpoint the rest of the
 * site's enquiry forms use, so these show up in the admin panel's existing
 * Enquiries section (and the "Services Enquiries" tab, via service_type)
 * alongside every other lead - no separate admin screen needed.
 */
const EnquiryForm = ({ sourceLabel, sourceUrl, title = 'Have a question?', subtitle = "Send us your details and we'll get back to you." }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      await api.post('/enquiries-submit', {
        name: values.name,
        email: values.email,
        phone_number: values.phone_number,
        service_type: 'general',
        description: values.message,
        additional_notes: sourceLabel ? `Submitted from: ${sourceLabel}${sourceUrl ? ` (${sourceUrl})` : ''}` : undefined
      });
      message.success("Thanks! We've received your enquiry and will get back to you soon.");
      form.resetFields();
    } catch (err) {
      message.error(err.response?.data?.message || 'Failed to submit your enquiry. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ background: '#f8fafc', borderRadius: 12, padding: 24, border: '1px solid #e2e8f0' }}>
      <h3 style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>{title}</h3>
      <p style={{ color: '#64748b', fontSize: 14, marginBottom: 20 }}>{subtitle}</p>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="name" rules={[{ required: true, message: 'Please enter your name' }]}>
          <Input placeholder="Your Name" />
        </Form.Item>
        <Form.Item name="email" rules={[{ required: true, type: 'email', message: 'Please enter a valid email' }]}>
          <Input placeholder="Email Address" />
        </Form.Item>
        <Form.Item name="phone_number" rules={[{ required: true, message: 'Please enter your phone number' }]}>
          <Input placeholder="Phone Number" />
        </Form.Item>
        <Form.Item name="message" rules={[{ required: true, message: 'Please enter your message' }]}>
          <TextArea rows={4} placeholder="How can we help?" />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={submitting} block style={{ background: '#06b590', border: 'none' }}>
          Submit Enquiry
        </Button>
      </Form>
    </div>
  );
};

export default EnquiryForm;
